import React from 'react'
import Ios from '../../../../assets/premium/ios.png'
import { theme } from '../../../../theme'

function IosIcon({ size = 1, color }) {
  return (
    <img
      alt={'IOS icon'}
      style={{
        filter:
          color === theme.colors.palette.slateGrey ? 'grayscale(100%)' : '',
        marginRight: `${20 * size}px`,
      }}
      width={32 * size}
      height={32 * size}
      src={Ios}
    />
  )
}

export default IosIcon
